import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { ScrollDispatcher, ViewportRuler } from '@angular/cdk/scrolling';

import { Inject, Injectable, NgZone, DOCUMENT } from '@angular/core';
import { ScrollService } from '@df/util/service/scroll.service';
import { ModalBlockScrollStrategy } from './modal-block-scroll-strategy';

@Injectable({
    providedIn: 'root'
})
export class ModalScrollStrategyOptions extends ScrollStrategyOptions {
    protected document: Document;
    protected viewportRuler: ViewportRuler;

    constructor(
        protected scrollService: ScrollService,
        _scrollDispatcher: ScrollDispatcher,
        _viewportRuler: ViewportRuler,
        _ngZone: NgZone,
        @Inject(DOCUMENT) document: any
    ) {
        super(_scrollDispatcher, _viewportRuler, _ngZone, document);

        this.document = document;
        this.viewportRuler = _viewportRuler;
    }

    override block = () => new ModalBlockScrollStrategy(this.viewportRuler, this.document, this.scrollService);
}
